import { CSSProperties } from "react";

export default class ConfirmAvailabilityHomeDialogViewStyle {
    date: CSSProperties = {
        fontWeight: 400
    }
}